import { useQuery } from "@tanstack/react-query"

import { getTraceabilityRequestsQueryParams } from "@tfg/types/schemas/traceabilityRequests"

import { httpClient } from "~/backend/axios"
import { useAuth } from "~/store/auth-context"

export const useGetTraceabilityRequestsIsSortableByOrderDate = ({
  filters,
}: {
  filters: getTraceabilityRequestsQueryParams["filters"]
}) => {
  const { user } = useAuth()
  return useQuery({
    queryKey: ["traceabilityRequestsIsSortableByOrderDate", filters, user?.id],
    queryFn: async () =>
      (
        await httpClient.get<boolean>(
          "/traceability-requests/sorts/order-date",
          {
            params: { filters },
          }
        )
      ).data,
  })
}
